import { useState, useRef, useEffect, FC } from "react";

interface IProps {
  question: string;
  answer: string | JSX.Element | JSX.Element[];
  onToggle: () => void;
  open: boolean;
}

const FaqItem: FC<IProps> = ({ question, answer, onToggle, open }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [_, setState] = useState<Boolean>(false);
  useEffect(() => {
    const onResize = () => setState((prev) => !prev);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div
      className={`tw-py-2 md:tw-py-3 xxxl:tw-py-[17.33px] tw-px-4 md:tw-px-6 xxxl:tw-px-[27px] tw-rounded-lg xxxl:tw-rounded-[10.67px] tw-mb-4 last:tw-mb-0 tw-transition-all tw-duration-500 tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-bg-[white] ${
        open
          ? "tw-border tw-border-solid !tw-border-[#007FAC] md:!tw-border-r-2 md:!tw-border-l-2 md:!tw-border-t-2 !tw-border-b-2 tw-shadow-lg"
          : "tw-border tw-border-solid tw-border-[#E5E9F4] md:!tw-border-r md:!tw-border-l md:!tw-border-t !tw-border-b"
      }`}
    >
      <div
        className="tw-flex tw-justify-between tw-items-center tw-cursor-pointer"
        onClick={() => onToggle()}
      >
        <div className="tw-relative">
          <h6
            className={`tw-text-[14px] xxxl:tw-text-[17.33px] tw-font-medium tw-transition-all ${
              open ? "tw-text-[#007FAC]" : "tw-text-[#344456]/60"
            }`}
          >
            {question}
          </h6>
        </div>

        {open ? (
          <div className="tw-mt-1 tw-rounded-full tw-p-3 tw-flex tw-justify-center tw-items-center tw-h-[30px] tw-w-[30px] xxxl:tw-min-h-[38.67px] xxxl:tw-min-w-[38.67px] tw-bg-[#007FAC]">
            <svg
              width="9"
              height="6"
              viewBox="0 0 9 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.56805 4.52854L4.53627 1.49745L1.50546 4.57025"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeّinejoin="round"
              />
            </svg>
          </div>
        ) : (
          <div className="tw-mt-1 tw-rounded-full tw-flex tw-justify-center tw-items-center tw-min-h-[30px] tw-min-w-[30px] xxxl:tw-min-h-[38.67px] xxxl:tw-min-w-[38.67px] tw-bg-[#E7ECF4]">
            <svg
              width="9"
              height="6"
              viewBox="0 0 9 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.43934 1.45031L4.4502 4.50218L7.50207 1.45031"
                stroke="#9EB1CC"
                strokeWidth="2"
                strokeLinecap="round"
                strokeّinejoin="round"
              />
            </svg>
          </div>
        )}
      </div>
      <div
        style={{ height: open ? (ref.current?.clientHeight || 0) + 18 : 0 }}
        className={`tw-transition-all tw-delay-[0ms] tw-duration-500 tw-overflow-hidden tw-relative`}
      >
        <p
          className="tw-text-tiny md:tw-text-md tw-text-[#344456] tw-h-fit tw-pt-[18px]"
          ref={ref}
        >
          {answer}
        </p>
      </div>
    </div>
  );
};

export default FaqItem;
